<!--
 * @Author: your name
 * @Date: 2021-04-02 14:15:03
 * @LastEditTime: 2021-04-15 14:55:54
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /ecmp5-client-web/src/views/station/Account.vue
-->
<template>
  <Nav-bar :has_back="true" :has_right="false" title="订单结算"></Nav-bar>
  <div class="top-margin"></div>
  <div class="back-container container">
    <div class="info-view">
      <div class="display_flex">
        <img
          src="@/images/charging_package_topup_result_success.png"
          class="success-icon"
        />
        <div class="m-l-10">
          <div class="t-f18-c1a font-bold">充电成功</div>
          <div class="t-f12-c28">{{ state.ordersStation }}</div>
        </div>
      </div>
    </div>
    <div class="list-item">
      <div class="item-v">
        <span class="t-f14-c28">充电时长</span>
        <span class="t-f14-c66 ab-r-t">{{state.ordersDetails.elapsedTime}}分钟</span>
      </div>
      <div class="item-v">
        <span class="t-f14-c28">充电电量</span>
        <span class="t-f14-c66 ab-r-t"
          >{{ state.ordersDetails.total_power }}度</span
        >
      </div>
      <div class="item-v" style="border: none">
        <span class="t-f14-c28">充电费用</span>
        <span class="t-f14-c66 ab-r-t">¥{{ state.ordersDetails.amount }}</span>
      </div>
    </div>
    <div class="m-20">
      <van-button type="primary" size="normal" class="main-btn" @click="goIndex"
        >返回首页</van-button
      >
    </div>
  </div>
</template>

<script>
import NavBar from "../../components/NavBar.vue";
import request from "@/api/request";
import { useRouter } from "vue-router";
import { reactive } from "vue";
import { useStore } from "vuex"
let state;
let router;
let stateContext;
export default {
  components: {
    NavBar: NavBar,
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  unmounted() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  methods: {
    goBack() {
     stateContext.commit("setHomeRouter","home")
      router.replace("/");
    },
  },
  setup() {
    router = useRouter();
    stateContext = useStore()
    state = reactive({
      ordersDetails: {},
      ordersStation: "",
    });
    getDetails(useRouter().currentRoute.value.params.id);
    return { state, goIndex, router };
  },
};
function getDetails(id) {
  request
    .getOrdersDetails(id)
    .then((res) => {
      state.ordersStation = res.data.charge_station.name;
      state.ordersDetails = res.data;
      state.ordersDetails.elapsedTime =  parseInt((new Date(res.data.completed_at) - new Date(res.data.start_charging_at))/60000)
    })
  
}
function goIndex() {
  router.replace("/");
}
</script>

<style scoped>
.back-container {
  background: linear-gradient(to bottom, #e2fff8, #f1f2f3);
  height: 236px;
}
.info-view {
  padding: 30px 35px;
}
.success-icon {
  width: 45px;
  height: 45px;
}
.list-item {
  border-radius: 5px;
  background: #fff;
  padding: 0px 20px;
  margin: 0px 15px;
}
.item-v {
  line-height: 50px;
  border-bottom: 1px solid #ebebeb;
  position: relative;
}
.ab-r-t {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
}
</style>